import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-cliente-numero-modal',
  templateUrl: './cliente-numero-modal.component.html',
  styleUrls: ['./cliente-numero-modal.component.scss']
})
export class ClienteNumeroModalComponent {
  constructor(
    public dialogRef: MatDialogRef<ClienteNumeroModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboard: Clipboard
  ) {}

  copiarNumeroCliente() {
    this.clipboard.copy(this.data.cliente.ic);
    this.dialogRef.close(this.data.cliente.ic); 
  }
}
